/**
 * App-wide stacking of fixed layers (lowest first). The stream dock sits above pages, menus, the panel
 * sheet (50), map overlays and the post dialog (1900) — so Play inside a post dialog plays in the visible
 * dock — but below the modals (2000: composer, uploads, cast pickers), the bottom nav (2000), notifications
 * (2050) and the media viewers (2100), which hold a wall YouTube item while they cover it (appOverlayStore).
 */
export const Z_POST_DIALOG = 1900;
/** The stream dock and the live PiP host. */
export const Z_DOCK = 1950;
/** Menus and small confirm dialogs that must stay above the dock (they cover none of its video). */
export const Z_ABOVE_DOCK = 1960;
/** The pre-login storage banner (privacy consent): above every screen and modal until the device answered. */
export const Z_CONSENT_BANNER = 2300;
/** The consent gate dialogs (date of birth, Before you start, re-consent, under 14): above the banner, they block. */
export const Z_CONSENT_GATE = 2400;
